module.exports = __webpack_public_path__ + "img/service.026e5c90.png";